import React, { useState } from 'react';
import './SocialShare.css';

export default function SocialShare({ playlist }) {
  const [copied, setCopied] = useState(false);

  if (!playlist || playlist.length === 0) return null;

  const songList = playlist.map((s, i) => `${i + 1}. ${s.title} - ${s.artist}`).join('\n');
  const shareText = `🎶 我的播放列表\n\n${songList}\n\n#音乐播放列表 #音乐推荐`;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareText).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  const shareToTwitter = () => {
    window.open(`https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, '_blank');
  };

  const shareToFacebook = () => {
    window.open(`https://www.facebook.com/sharer/sharer.php?quote=${encodeURIComponent(shareText)}`, '_blank');
  };

  return (
    <div className="social-share">
      <h4>📤 分享播放列表</h4>
      <div className="share-buttons">
        <button className="share-btn twitter" onClick={shareToTwitter}>
          𝕏 Twitter
        </button>
        <button className="share-btn facebook" onClick={shareToFacebook}>
          📘 Facebook
        </button>
        <button className="share-btn copy" onClick={copyToClipboard}>
          {copied ? '✅ 已复制!' : '📋 复制到剪贴板'}
        </button>
      </div>
    </div>
  );
}
